var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PublicLayout',[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('donate.title')))]),_c('div',[_c('p',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.$t('donate.text'))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }